
import axios from 'axios';


const ApiCaller = async (method, url, data = null, headers = {}) => {
  
    if (!url) {
      throw new Error('URL is required');
    }
    
    try {
      const config = {
        method: method.toLowerCase(), 
        url,
        headers: {
          'Content-Type': 'application/json',
          ...headers, 
        },
      };
     
    if (data && ['post', 'put', 'patch'].includes(method.toLowerCase())) {
      config.data = data;
    }
        
    const response = await axios(config);    
    return response;    
    }
    catch (error) {
      throw  error;
    }
  

};

export default ApiCaller;